import { ComboboxItem } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { profileQKeys } from "./queryKeys";


interface SpecialtyResponse {
  _id: string;
  name: string;
}

const queryFn = () => {
  return api.get("profile/specialty/all");
};

const select = (res: any) => {
  if (res.data && Array.isArray(res.data)) {
    const newData: ComboboxItem[] = res.data.map((specialty: SpecialtyResponse) => ({
      label: specialty.name,
      value: specialty._id,
    }));
    
    return newData;
  }
  return [];
};

export const useGetSpecialties = () => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: profileQKeys.specialties(),
    queryFn,
    select,
    staleTime: Infinity, // Specialties don't change often
    
    onError: (res: any) => {
      console.error("[From Get Specialties]", res);
      handleErrors(res, "query");
    },
  });
};
